module.exports = __webpack_public_path__ + "assets/img/pdf.746a742b.svg";